export const setList = (state, payload) => state.list = payload
export const setTree = (state, payload) => state.tree = payload;
